type WindowWithClerk = Window & { Clerk?: { user?: { id?: string } | null } };

export const getCurrentClerkUserId = (): string | null =>
  (window as WindowWithClerk).Clerk?.user?.id ?? null;
